<template>
    <footer>
        <div class="footer-container">
            <div class="footer-section" v-for="(section, index) in footerSections" :key="index">
                <h3>{{isEnglish ? section.titleen : section.title }}</h3>
                <ul  style="cursor: pointer;"  :class="{ 'social-links': section.title === '关注谱褀' }">
                    <li class="" v-for="(item, i) in section.items" :key="i" style="position: relative;">
                    
                    
      
                        <!-- 使用条件渲染来处理社交媒体图标的不同结构 -->
                        <img
                       style="cursor: pointer;"
                         v-if="section.title === '关注谱褀'" :src="item.src" :alt="item.alt" @click="openi(item.http)"></img>

                        <span  @mouseover="showHoverImage(item.hoverSrc)"
                        @mouseleave="hideHoverImage" v-if="section.title === '关注谱褀'">{{isEnglish ? item.mintitleen : item.mintitle }}</span>
                        <span v-else style="cursor: pointer;"  @click="openi(item.http)">{{isEnglish ? item.mintitleen :  item.mintitle }}</span>
                    </li>
                </ul>
                
            </div>
            <!-- 悬停图片 -->
            <img 
            v-if="hoverImageSrc" 
            :src="hoverImageSrc"
            @error="hoverImageSrc = ''"
             style="position: absolute; left: 80vw;top: 20vh; width: 20vw;height: auto;"> </img>
        </div>


        <div class="footer-bottom">
            <div class="footer-bottom-left leftbottom">
                <p class="leftbottomp">{{isEnglish ? companynameen : companyname}}</p>
                <p>{{companyemail}}</p>

            </div>
            <div class="footer-bottom-center">
                <p  @click="goToLink(copyrightnotice)" class="footer-text" style="position: relative;"><img style="position: absolute;top:4px ;left:50px; height: auto;width:13px" src="@/assets/gongan.png" alt="" > {{ copyrightnotice }}</p>
                <div class="footer-info">
                    <p class="footer-item">{{icpnumber}}</p>
                    <p  @click="openi(licenses.licensesrc)" class="footer-item">{{isEnglish ? licenses.licensestitleen :licenses.licensestitle}}</p>
                </div>
            </div>

            <div class="footer-bottom-right" >
                <div v-for="(item, i) in linkss" :key="i">
                <p @click="openi(item.linksserc)">{{isEnglish ? item.linkstitleen :item.linkstitle}}</p>
            </div>

            </div>
        </div>
    </footer>
</template>

<script>
 import axios from 'axios';
    import apiUrls from '@/http/http'; // 假设 http.js 在 src/http 目录下
    import { mapActions, mapState } from 'vuex';
    export default {

        components:{
        },
        data() {
            return {
               
                companynameen:'广州谱褀商业发展有限公司22',//公司名
                companyname:'广州谱褀商业发展有限公司',//公司名
                companyemail:'E-mail: coop@puki.vip',//公司邮箱
                links:'友情链接(铭恒供应链)',//友情链接
                linkss:[
                    {
                       linkstitleen:'友情链接(sss)',
                    
                    linkstitle:'友情链接(铭恒供应链)',
                    linksserc:'https://www.baidu.com/'
                },
               
               
            ],
                copyrightnotice:'粤公网安备44011502001331号',//版权声明
                icpnumber:'粤公网安备44011502001331号',//备案号
                license:'经营执照',//营业执照
                licenses:{
                    licensestitleen:'经营2执照',
                    licensestitle:'经营执照',
                    licensesrc:'www.baidu.com',
                },
                // hoverImageSrc:require('../../assets/weixin.png'),
                hoverImageSrc:'',
                footerSections: [
                    {
                        title: '产品选购',
                        items: [{mintitle:'P系列',http:'/#/products/collectionA',hoverSrc:"" ,textcontent: '',src:""},
                        {mintitle:'U系列',http:'/#/products/collectionU',hoverSrc:"" ,textcontent: '',src:""},
                        {mintitle:'K系列',http:'/#/products/collectionK',hoverSrc:"" ,textcontent: '',src:""},
                        {mintitle:'E系列',http:'/#/products/collectionE',hoverSrc:"" ,textcontent: '',src:""},
                        {mintitle:'C系列',http:'/#/products/collectionC',hoverSrc:"" ,textcontent: '',src:""},
                        {mintitle:'更多...',http:'',hoverSrc:"" ,textcontent: '',src:""}]
                    },
                    {
                        title: '探索谱褀',
                        items: [ {mintitle:'品牌定位',http:'/#/positioning',hoverSrc:"" ,textcontent: '',src:""},
                         {mintitle:'研发设计',http:'/#/positioning',hoverSrc:"" ,textcontent: '',src:""},
                          {mintitle:'绿色智造',http:'/#/positioning',hoverSrc:"" ,textcontent: '',src:""},
                           {mintitle:'展示中心',http:'/#/exhibitioncenter',hoverSrc:"" ,textcontent: '',src:""},]
                    },
                    {
                        title: '用户服务',
                        items: [{mintitle:'售后服务',http:'',hoverSrc:"" ,textcontent: '',src:""},
                        {mintitle:'联系我们',http:'',hoverSrc:"" ,textcontent: '',src:""},
                        {mintitle:'常见问题',http:'',hoverSrc:"" ,textcontent: '',src:""},]
                    },
                    {
                        title: '关注谱褀',
                        items: [
                            {mintitle:'联系我们', src: require('../../assets/pic-66.png'), alt: '微信', textcontent: '微信',http:'',hoverSrc: require('../../assets/weixin.png'), },
                            {mintitle:'联系我们',  src: require('../../assets/pic-67.png'), alt: '小红书', textcontent: '小红书',http:'' ,hoverSrc: require('../../assets/weixin.png'),},
                            {mintitle:'联系我们',  src: require('../../assets/facbook.png'), alt: 'facebook', textcontent: 'facebook' ,http:'https://www.facebook.com/profile.php?id=100092522696676',hoverSrc: require('../../assets/weixin.png'),},
                            {mintitle:'联系我们',  src: require('../../assets/pic-65.png'), alt: '京东', textcontent: '京东',http:'' ,hoverSrc: '',}
                        ]
                    }
                ],
                currentIndex: 0,
                title: {
                    pukititle: false,
                },
                isMobile: false,
                sections: [],
              
            };
        },
        // computed(){
        //
        // },
        computed: {
             // 从 Vuex 的 state 中获取 isEnglish 数据
             ...mapState(['isEnglish']), // 这里读取 state 中的 isEnglish 状态
              // Vuex 的 actions 映射到 methods
              ...mapActions(['changeLanguage']),
             
        },
        mounted() {
        // 初次加载时立即调用一次 fetchData，确保使用当前的 isEnglish
        this.fetchData();

        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            /**
             * 获取页面数据
             */
             async fetchData() {
                try {
                     // 发起API请求
                     const response = await axios.get(`${apiUrls.baseUrl}/website/api/getbottompc`);
                        //    console.log(response.data)
                    if(response.data && response.data.length > 0){
                        const data = response.data[0]; // 假设只需要第一个对象的数据
                        this.companyname=data.companyname;
                        this.companynameen=data.companynameen
                        this.companyemail=data.companyemail;
                        this.copyrightnotice=data.copyrightnotice;
                        this.icpnumber=data.icpnumber;

                        const titles = data.linkstitle.split('，');
                        const titlesen = data.linkstitleen.split('，');
                        const serc = data.linksserc.split('，');
                        this.linkss=titles.map((title,index)=>({
                            linkstitle: title,
                            linkstitleen: titlesen[index],
                            linksserc: serc[index]
                        }));

                        this.licenses.licensestitle=data.licensestitle
                        this.licenses.licensestitleen=data.licensestitleen
                        this.licenses.licensesrc=data.licensesrc

                        this.footerSections=response.data.map(section=>{
                             // 使用逗号分隔 `mintitle` 和 `http` 字段创建 items 数组
                             const mintitles = section.mintitle ? section.mintitle.split('，') : [];
                             const mintitlesen = section.mintitle ? section.mintitleen.split('，') : [];
                             const urls = section.http ? section.http.split('，') : [];
                            const textcontent1=section.textcontent? section.textcontent.split('，') : [];
                             const src=section.src? section.src.split(',') : [];
                             const hoverSrc=section.hoverSrc? section.hoverSrc.split(',') : [];
                            const items=mintitles.map((mintitle,index)=>({
                                mintitle: mintitle.trim(),
                                mintitleen: mintitlesen[index]?.trim() ,
                                http: urls[index]?.trim() || '',  // 若无对应 URL，则为 ''
                                hoverSrc: section.hoverSrc || '', // 为空时默认为空字符串
                                textcontent: textcontent1[index]?.trim() || '',
                                src:`${apiUrls.devApi}${src[index]?.trim()}` || '',
                                hoverSrc:`${apiUrls.devApi}${hoverSrc[index]?.trim()}` || null,
                             }));
                             return {
                                        title: section.title, 
                                        titleen:section.titleen,
                                        items
                                    };
                        })


                        // console.log(this.footerSections)
                    }
                    
                } catch (error) {
                    console.error('获取数据失败:', error);
                }
             },



                     showHoverImage(image) {
                     this.hoverImageSrc = image; // 鼠标悬停时更新图片路径
                    },
                    hideHoverImage() {
                     this.hoverImageSrc = ''; // 鼠标移出时清空图片路径
                  
                    },
            openi(item){
                window.open(item)
            },
            goToLink(itme) {
                window.open(`https://beian.mps.gov.cn/#/query/webSearch?code=${itme}`);  // 在新窗口中打开链接
                    },


        },



        created() {

        },
    };
</script>

<style scoped>
/* 悬停显示的图片样式 */
.hover-overlay {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 80vw;
  max-height: 80vh;
  z-index: 1000;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

    /*    底部页脚开始*/

    /*    底部页脚开始*/
    /*    底部版本声明开始*/
    .leftbottomp{
       
    }
    .footer-text{
        width: 21rem;
        margin: 0;
        text-align: center; /* Center align the copyright text */
    }
    .footer-info {
        display: flex;
        justify-content: center; /* Center align the items horizontally */
        gap: 1vw; /* Adjust the gap between items as needed */
    }

    .footer-item {
        margin: 0;
    }
    /*底部版本声明结束*/
    footer {
       
        background-color: #000;
        color: #fff;
       
      height: 100vh;
        overflow: hidden; /* 隐藏溢出的内容 */
        max-height: 97vh; /* 限制最大高度 */
    }


    .footer-container {
        margin: 7rem auto; /* 自动居中 */
        display: flex;
        justify-content: space-between; /* 控制集合之间的水平间距 */
        flex-wrap: wrap;
        padding: 0 10rem; /* 增加内边距，确保离屏幕两端有足够的间距 */
        
    /*   */
    }

    .footer-section {
        flex: 1;
        min-width: 150px; /* 设置最小宽度 */
        text-align: center; /* 确保内容左对齐 */
         margin: 15px 8px; /*减少集合的外边距 */
    }

    .footer-section h3 {
        font-weight: lighter;
        font-size: 0.8rem;
        color: white;
        padding-bottom: 8px; /* 减少下内边距 */
        margin-bottom: 8px; /* 减少下外边距 */
        text-align: left; /*!* 标题左对齐 *!
        
        margin-right: calc(8vw + 20px); /* 使用 calc 动态变化 */
        margin-left: 5rem;
    }

    .footer-section ul {
        list-style: none;
        padding: 0;
        margin: 0; /* 移除外边距 */
        text-align: center; /* 列表内容左对齐 */
    }

    .footer-section ul li {
        color: white;
        font-weight: 200;
        font-size: 1rem;
        margin-bottom: 1rem; /* 减少列表项之间的间距 */
        display: flex;
        align-items: center; /* 垂直居中对齐 */
        padding-left: 5rem; /* 向右移动列表项，调整这个值来控制移动距离 */
    }

    .footer-section ul li img {
        width: 20px; /* 调整图标大小 */
        height: 20px;
        margin-right: 0.3rem; /* 减少图标与文本之间的间距 */
    }

    .social-links {
        padding: 0;
        list-style: none;
    }

    .social-links li {
        display: flex;
        align-items: center;
        margin-bottom: 1rem; /* 减少列表项之间的间距 */
    }

    .social-links li img {
        width: 25px; /* 调整图标大小 */
        height: 25px;
        margin-right: 6px; /* 减少图标与文本之间的间距 */
    }


    .footer-bottom {
        margin-top: 2rem;
        font-size: 0.9rem;
        color: #9b9797;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 2rem;
        /*border-top: 1px solid #fff;*/
        text-align: center;
        
    }

    .footer-bottom-left,
    .footer-bottom-right {
        flex: 1;
        /*align-items: flex-start; !* Align items to the start of the flex container (left-align) *!*/
        margin-right: 2rem;
         /* 当鼠标悬停时，改变光标为手指 */
  cursor: pointer;
       
        
    }
    .footer-bottom-right{
        display: flex;
        flex-direction: column; /* 垂直排列 */  
        justify-content: center;
    }


    .footer-bottom-center {
         /* 当鼠标悬停时，改变光标为手指 */
  cursor: pointer;
        flex: 0;
    }

    .footer-bottom-center img {
        height: 30px; /* 根据需要调整高度 */
        width: 40px;
    }
    .footer-bottom p {
        margin: 5px 0;
    }
    /*    底部页脚结束*/
    /*网页底部结束*/
    /*网页底部结束*/
/*    手机端样式隐藏*/
    @media screen and (max-width: 768px) {
footer{
    display: none;
}

    }
/*    手机端样式隐藏
*/

/* 针对更大的台式电脑（如 1920px 以上） */
@media (min-width: 1920px) {
    .footer-section h3{
        font-weight: 400;
    }
    .footer-section ul li{
        font-weight: 300;
    }
.footer-section ul{
    margin-left: 2rem;
}
.footer-section h3{
    margin-left: 7rem!important;
}
}
</style>
